import { DrawerContent } from '@chakra-ui/react'

export default DrawerContent
